module.exports = __webpack_public_path__ + "static/media/bg_thai01.f3daf508.png";